// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3ZpcN","author":"Table_author__3u2sA","authorImage":"Table_authorImage__RiieL","unreadRow":"Table_unreadRow__ZTK3D"};